// extracted by mini-css-extract-plugin
export var cardLayout = "_22-1";
export var paginationContainer = "_22-0";